import { useState } from 'react';
import { useIdListFromQueryString } from '../../../../../../misc/useIdListFromQueryString';
import { useEventSpeakers } from '../../../../../../data/hooks/speakers/useEventSpeakers';

export function useInvitedSpeakersState(eventId) {
    const speakers = useEventSpeakers(eventId),
        initialSpeakers = useIdListFromQueryString('speakers')
            .map((id) => speakers.find((s) => s.id == id))
            .map((s) => s.id),
        [selection, setSelection] = useState(initialSpeakers);

    return [selection, setSelection];
}
